<script setup>
const props = defineProps({
  content: Array,
});
</script>

<template>
  <div class="l-container">
    <div class="p-section">
      <template v-for="item in content">
        <ContentTypesText
          v-if="item.type === 'contentText'"
          :text="item.text"
          class="prose prose--max-w"
        />
        <ContentTypesImage
          v-else-if="item.type === 'contentImage'"
          :image="item.image"
        />
        <ContentTypesAccordion
          v-else-if="item.type === 'contentAccordion'"
          :title="item.title"
          :items="item.accordions"
        />
      </template>
    </div>
  </div>
</template>
